import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/collapseShadeSelectors/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showCollapseShadeSelectorsSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showCollapseShadeSelectorsSelector };
